import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import useFeatureFlag from 'src/common/hooks/useFeatureFlag';
import Button from 'src/common/components/ButtonDS22';
import useLanguageChange from 'src/common/hooks/useLanguageChange';
import { EXTERNAL_PATHS, PATHS } from '../../constants';
import getClassNames from '../../utils/getClassNames';
import NavItem from './NavItem';
import LanguageSelector from '../LanguageSelector';
import CurrencySelectorInput from '../CurrencySelectorInput';
import TopNavItemWrapper from './TopNavItemWrapper';
import UniversalLink from '../UniversalLink';
import style from './Navigation.module.scss';

type UnauthenticatedNavItemsProps = {
  classNameModifier?: string;
};

const UnauthenticatedNavItems: FC<UnauthenticatedNavItemsProps> = ({
  classNameModifier = '',
}) => {
  const isAuthMigrationEnabled = useFeatureFlag('auth-migration');
  const REGISTER = isAuthMigrationEnabled ? PATHS.REGISTER : EXTERNAL_PATHS.REGISTER;
  const LOGIN = isAuthMigrationEnabled ? PATHS.LOGIN : EXTERNAL_PATHS.LOGIN;
  const linkClassName = getClassNames(style, 'link', classNameModifier);
  const [t] = useTranslation('navbar');
  const { onLanguageChange } = useLanguageChange();
  return (
    <>
      <TopNavItemWrapper classNameModifier={classNameModifier}>
        <NavItem
          to={PATHS.ADMIN_LISTINGS}
          classNameModifier={classNameModifier}
        >
          {t('list-your-boat')}
        </NavItem>
      </TopNavItemWrapper>
      <TopNavItemWrapper classNameModifier={classNameModifier}>
        <LanguageSelector onChange={onLanguageChange} />
      </TopNavItemWrapper>
      <TopNavItemWrapper classNameModifier={classNameModifier}>
        <CurrencySelectorInput location="topNav" />
      </TopNavItemWrapper>
      <TopNavItemWrapper classNameModifier={`${classNameModifier} login`}>
        <UniversalLink
          className={linkClassName}
          href={LOGIN}
        >
          {t('login')}
        </UniversalLink>
      </TopNavItemWrapper>
      <TopNavItemWrapper classNameModifier={classNameModifier}>
        <Button
          href={REGISTER}
          variant="tertiary"
          size="small"
          type="link"
        >
          {t('create-account')}
        </Button>
      </TopNavItemWrapper>
    </>
  );
};

export default UnauthenticatedNavItems;
